import React, {useState, useEffect} from 'react'
import apiClient from '../api/apiClient'
//import {useAuth} from '../context/AuthContext'
import {useLocation} from 'react-router-dom'


export default function FinalExamGradingPage(){
 //   const {user} = useAuth()
   // const userID = user.id
    const {state} = useLocation()
    const testGroupID = state.testGroupID

    const [studentList, setStudentList] = useState([])
    const [currentTestGroup, setCurrentTestGroup] = useState(null)

    async function fetchTestGroup(){
        try{
            const result = await apiClient.get('/api/testgroup/gettestgroup',{
                params: {testGroupID: testGroupID}
            })
            setCurrentTestGroup(result.data)
        }catch(e){
            console.log("fejl ved hent af testgruppe")
            console.log(e)
        }
    }


    async function fetchStudents(){
        try{
            const result = await apiClient.get('/api/testgroup/getstudentsintestgroup', {
                params: {testGroupID: testGroupID || null}
            })

            const theStudents = result.data.map(student =>
                student.endelig_karakter === null ?(
                    {
                        ...student, 
                        endelig_karakter: {
                            laese1_grade: '',
                            laese1_comment : '',
                            laese2_grade: '',
                            laese2_comment : '',
                            skrive_grade: '',
                            skrive_comment: ''
                        }
                    }                
                ): 
                (
                    student
                )
            )
            setStudentList(theStudents)
        }catch(e){
            console.log("fejl ved hent af kursister")
            console.log(e)
        }
    }

    useEffect(()=>{
        fetchTestGroup()
        fetchStudents()
    }, [])

    async function handleChange(e, studentID){
        e.preventDefault()
        const{name, value} = e.target
        const currentStudent = studentList.find(s => s.id === studentID)

        const newStudent = {...currentStudent, 
                            endelig_karakter: {...currentStudent.endelig_karakter, [name]: value}
        }
        setStudentList(studentList.map(student => student.id === studentID? newStudent : student))

        try{
            await apiClient.post('/api/testgroup/updatefinalgrades', {student: newStudent})
        }catch(e){
            console.log("fejl ved gemning af endelig karakter")
            console.log(e)
        }
    }

    async function commitGrades(){
        try{
            await apiClient.post('/api/testgroup/commitgrades', {testGroupID: testGroupID, type:"finalcommit"})
        }catch(e){
            console.log("fejl ved commit af final grade")
            console.log(e)
        }
    }

        const rows =2
        const cols = 30
    function GradeCell(props){
        const {inputOrArea, name, value, locked, studentID} = props


        return(
            <td>
                {inputOrArea ? 
                (<input type="text" defaultValue="0" name={name}
                value={value} locked = {locked}
                onChange={(e)=>handleChange(e,studentID)}/>
            ):(
                <textarea rows={rows} cols={cols} name={name}
                value={value}
                onChange={(e)=>handleChange(e,studentID)}/>
            )}
            </td>
        )
    }

    return(
        <div className="panel-section">
            <div className="panel">
                {studentList.length ===0 ? (
                    <p>Ingen studerende fundet</p>
                ):(
                <div>
                    <div>
                        {currentTestGroup?.gradecommit_final ? (
                            <h2>Prøvekarakter låste. Prøven er afsluttet.</h2>
                        ): (
                            <button onClick={commitGrades}>Afslut karaktergivning</button>
                        )
                        }
                     </div>   
                    <table className="censor-table">
                        <thead>
                            <tr>
                                <th style={{width: '5%'}}>Kursist ID</th>
                                <th style={{width: '15%'}}>Fornavn(e)</th>
                                <th style={{width: '15%'}}>Efternavn</th>
                                <th style={{width: '65%'}}>Karakter</th>
                            </tr>
                        </thead>
                        <tbody>
                            {studentList.map(student =>                                 
                                    (<tr key={student.id}>
                                        <td>{student.id}</td>
                                        <td>{student.fornavne}</td>
                                        <td>{student.efternavn}</td>
                                        <td>
                                            <fieldset disabled={currentTestGroup?.gradecommit_final} 
                                            style={{border: 'none', padding: 0, margin: 0}}>
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th style={{width: '25%'}}>Prøve</th>
                                                        <th style={{width: '5%'}}>Eksaminator karakter</th>
                                                        <th style={{width: '5%'}}>Censor karakter</th>
                                                        <th style={{width: '5%'}}>Endelig karakter</th>
                                                        <th style={{width: '60%'}}>Kommentar</th>
                                                    </tr>
                                                </thead>
                                                <tr>
                                                    <td><label>Læseprøve 1</label></td>
                                                    <td>{student.underviser_karakter.laese1_grade}</td>
                                                    <td>{student.censor_karakter.laese1_grade}</td>
                                                    <GradeCell inputOrArea={true} 
                                                    name="laese1_grade" value={student.endelig_karakter.laese1_grade}
                                                    locked={false} studentID={student.id}/>
                                                    <GradeCell inputOrArea={false} 
                                                    name="laese1_comment" value={student.endelig_karakter.laese1_comment}
                                                    locked={false} studentID={student.id}/>
                                                </tr>
                                                <tr>
                                                    <td><label>Læseprøve 2 </label></td>
                                                    <td>{student.underviser_karakter.laese2_grade}</td>
                                                    <td>{student.censor_karakter.laese2_grade}</td>
                                                  
                                                    <td><input type="text" defaultValue="0" name="laese2_grade"
                                                    value={student.endelig_karakter.laese2_grade}
                                                    onChange={(e)=>handleChange(e,student.id)}/></td>
                                                    <td>
                                                    <textarea rows={rows} cols={cols} name="laese2_comment"
                                                    value={student.endelig_karakter.laese2_comment}
                                                    onChange={(e)=>handleChange(e,student.id)}/></td>
                                                </tr>
                                                <tr>
                                                    <td><label>Skriftlig prøve </label></td>
                                                    <td>{student.underviser_karakter.skrive_grade}</td>
                                                    <td>{student.censor_karakter.skrive_grade}</td>
                                                    <td><input type="text" defaultValue="0" name="skrive_grade"
                                                    value={student.endelig_karakter.skrive_grade}
                                                    onChange={(e)=>handleChange(e,student.id)}/></td>
                                                    <td>
                                                    <textarea rows={rows} cols={cols} name="skrive_comment" 
                                                    value={student.endelig_karakter.skrive_comment}
                                                    onChange={(e)=>handleChange(e,student.id)}/></td>
                                                </tr>
                                            </table>
                                            </fieldset>
                                        </td>
                                    </tr>)                            
                            ) 
                            }
                        </tbody>
                    </table>
                </div>
                )}
            </div>
        </div>
    )
}